import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Dashboard.css';
import MainMenu from './MainMenu';
import Messages from './Messages';

const Dashboard = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeMenu, setActiveMenu] = useState('الرئيسية');
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [recrutements, setRecrutements] = useState([]);
  const [recrutementLoading, setRecrutementLoading] = useState(false);
  const [recrutementError, setRecrutementError] = useState(null);

  useEffect(() => {
  const fetchSuppliers = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://alaussback-production.up.railway.app/api/suppliers/readInfos');
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      setSuppliers(data);
      setError(null);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchRecrutements = async () => {
    if (activeMenu !== 'التوظيف') return;
    setRecrutementLoading(true);
    try {
      const response = await fetch('https://alaussback-production.up.railway.app/api/recrutments');
      if (!response.ok) throw new Error(`Error: ${response.status}`);
      const data = await response.json();
      setRecrutements(data);
      setRecrutementError(null);
    } catch (err) {
      setRecrutementError(err.message);
    } finally {
      setRecrutementLoading(false);
    }
  };

  fetchSuppliers();
  fetchRecrutements();
}, [activeMenu]);





  
  const viewPdf = (supplierId, documentType) => {
    return `https://alaussback-production.up.railway.app/api/suppliers/documents/${supplierId}/${documentType}`;
  };

  const menuItems = [
    { name: 'الرئيسية', icon: '🏠' },
    { name: 'الموردين', icon: '👥' },
    { name: 'التوظيف', icon: '📄' } ,
    { name: 'الرسائل', icon: '📄' }
  ];


  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="dashboard">
      <nav className="navbar">
        <div className="navbar-right">
          <button className="sidebar-toggle" onClick={toggleSidebar}>☰</button>
          <h4 style={{ fontFamily: 'Cairo, sans-serif', color: 'white' }}>لوحة التحكم</h4>
        </div>
        <div className="navbar-left">

          <div className="user-profile">
            <span>مرحباً، أحمد!</span>
            <div className="avatar">👤</div>
          </div>
        </div>
      </nav>

      <div className="main-content">
        <aside className={`sidebar ${sidebarOpen ? 'open' : 'closed'}`}>
          <ul className="menu" >
            {menuItems.map(item => (
              <li
                key={item.name}
                className={activeMenu === item.name ? 'active' : ''}
                onClick={() => setActiveMenu(item.name)}
              >
                <span className="menu-icon" >{item.icon}</span>
                <span className="menu-text" style={{ fontFamily: 'Cairo, sans-serif' }}>{item.name}</span>
              </li>
            ))}
          </ul>
          <div className="sidebar-footer">
            <button className="logout-btn">
              <span>🚪</span>
              <span>تسجيل الخروج</span>
            </button>
          </div>
        </aside>
        <main className="content">

          {activeMenu === 'الرئيسية' && (
            <div>
              <MainMenu/>
            </div>

          )}


          {activeMenu === 'الرسائل' && 
            <div>
              <Messages/>
            </div>
          
          }


          {activeMenu === 'الموردين' && (

          <div className="dashboard-sections">
            <section className="recent-orders">
              <h3 style={{ fontFamily: 'Cairo, sans-serif' }}>جميع الموردين المسجلين</h3>
              <div className="table-container">
                {loading ? (
                  <p>جاري تحميل البيانات...</p>
                ) : error ? (
                  <p style={{ color: 'red' }}>خطأ في تحميل البيانات: {error}</p>
                ) : (
                  <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <thead>
                      <tr>
                        <th>الاسم</th>
                        <th>البريد الإلكتروني</th>
                        <th>رقم الهاتف</th>
                        <th>معلومات البنك</th>
                        <th>السجل التجاري</th>
                        <th>شهادة التأمينات</th>
                        <th>شهادة ضريبة القيمة المضافة</th>
                        <th>المنتجات والخدمات</th>
                        <th>الغرفة التجارية</th>
                        <th>شهادة الزكاة</th>
                      </tr>
                    </thead>
                    <tbody>
                      {suppliers.map((supplier) => (
                        <tr key={supplier.id}>
                          <td>{supplier.username}</td>
                          <td>{supplier.email}</td>
                          <td>{supplier.phone}</td>
                          <td>
                            {supplier.bankInfo ? (
                              <a
                                href={viewPdf(supplier.id, 'bankinfo')}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                عرض PDF
                              </a>
                            ) : 'لا يوجد'}
                          </td>
                          <td>
                            {supplier.registrationDoc ? (
                              <a
                                href={viewPdf(supplier.id, 'registrationdoc')}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                عرض PDF
                              </a>
                            ) : 'لا يوجد'}
                          </td>
                          <td>
                            {supplier.gosi ? (
                              <a
                                href={viewPdf(supplier.id, 'gosi')}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                عرض PDF
                              </a>
                            ) : 'لا يوجد'}
                          </td>
                          <td>
                            {supplier.vat ? (
                              <a
                                href={viewPdf(supplier.id, 'vat')}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                عرض PDF
                              </a>
                            ) : 'لا يوجد'}
                          </td>
                          <td>
                            {supplier.products ? (
                              <a
                                href={viewPdf(supplier.id, 'products')}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                عرض PDF
                              </a>
                            ) : 'لا يوجد'}
                          </td>
                          <td>
                            {supplier.chamber ? (
                              <a
                                href={viewPdf(supplier.id, 'chamber')}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                عرض PDF
                              </a>
                            ) : 'لا يوجد'}
                          </td>
                          <td>
                            {supplier.zakat ? (
                              <a
                                href={viewPdf(supplier.id, 'zakat')}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                عرض PDF
                              </a>
                            ) : 'لا يوجد'}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
              <Link to="/suppliers" className="view-all">
                عرض الكل →
              </Link>
            </section>
          </div>
)}

{activeMenu === 'التوظيف' && (
  <section className="recent-orders">
    <h3 style={{ fontFamily: 'Cairo, sans-serif' }}>طلبات التوظيف</h3>
    {recrutementLoading ? (
      <p>جاري تحميل بيانات التوظيف...</p>
    ) : recrutementError ? (
      <p style={{ color: 'red' }}>خطأ في التحميل: {recrutementError}</p>
    ) : (
      <table border="1" style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr>
            <th>الاسم</th>
            <th>الهاتف</th>
            <th>الموقع</th>
            <th>المجال</th>
            <th>الاختصاص</th>
            <th>الوصف</th>
            <th>رابط السيرة الذاتية</th>
          </tr>
        </thead>
        <tbody>
          {recrutements.map((rec) => (
            <tr key={rec.id}>
              <td>{rec.name}</td>
              <td>{rec.phoneNumber}</td>
              <td>{rec.location}</td>
              <td>{rec.domaine}</td>
              <td>{rec.speciality}</td>
              <td>{rec.description}</td>
              <td>
                {rec.CV ? (
                  <a
                    href={`data:application/octet-stream;base64,${btoa(rec.CV)}`}
                    download={`CV-${rec.name}.txt`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    تحميل
                  </a>
                ) : 'غير متوفر'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    )}
  </section>
)}


        </main>
      </div>
    </div>
  );
};

export default Dashboard;